import { useContext, useEffect } from "react";
import { ReportContext } from "./context";

interface Props {
  reportName: string;
  onDownloading: (downloading: boolean) => void;
}

export const useReportContext = ({ reportName, onDownloading }: Props) => {
  const { accessor: context } = useContext(ReportContext);

  useEffect(() => {
    const dailyLog = context?.getReport(reportName);
    if (dailyLog) {
      onDownloading(false);
      if (dailyLog.success && dailyLog.reportUrl) {
        let a = document.createElement("a");
        a.href = dailyLog.reportUrl;
        a.click();
      }
    }
  }, [context, onDownloading, reportName]);
};
